import React from "react";
import { t } from "i18next";
import moment from "moment";
import { Util } from "common/util";
import { InputRangeDate } from "common/elements";
import { getMany } from "services/leave";
import {
  Approved,
  Rejected,
  Pending,
  Cancelled
} from "common/status";
import Enum from "common/enums";
import withDataTable from "./withDataTable";
import FormReview from "./FormReview";
import FormInsertOrUpdate from "./FormInsertOrUpdate";
import EmployeeProfile from "common/components/EmployeeProfile";

const util = new Util();
const pathName = "/leaves";
const columns = [
  {
    title: t("text_request_no"),
    dataIndex: "requestNo",
    key: "requestNo",
    width: 140
  },
  {
    title: t("text_employee_name"),
    dataIndex: "employeeName",
    key: "employeeName",
    render: (employeeName, record) => {
      return (
        <EmployeeProfile photo={record.photo} employeeName={record.employeeName} />
      );
    },
  },
  {
    title: t("text_status"),
    dataIndex: "status",
    key: "status",
    render: (status) => {
      if (status === Enum.LEAVESTATUS.APPROVED) {
        return <Approved />;
      } else if (status === Enum.LEAVESTATUS.REJECTED) {
        return <Rejected />;
      } else if (status === Enum.LEAVESTATUS.REQUESTED) {
        return <Pending />;
      } else if (status === Enum.LEAVESTATUS.CANCELLED) {
        return <Cancelled />;
      }
    },
  },
  {
    title: t("text_requested_date"),
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt) => createdAt && util.formatDate(createdAt),
  },
  {
    title: t("text_leave_type"),
    dataIndex: "leaveName",
    key: "leaveName",
  },
  {
    title: t("text_leave_from"),
    dataIndex: "start",
    key: "start",
    render: (start) => start && moment(start).format("ddd DD MMM, YYYY"),
  },
  {
    title: t("text_leave_to"),
    dataIndex: "end",
    key: "end",
    render: (end) => end && moment(end).format("ddd DD MMM, YYYY"),
  },
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
  defaultCurrent = current;
}

if (size) {
  defaultPageSize = size;
}

const getData = () => {
  let limit = defaultPageSize;
  let current = defaultCurrent;
  let option = {};
  let filter = {};
  const params = new URLSearchParams(document.location.search);
  const searchStr = params.get("search");

  if (params.get("size")) {
    limit = params.get("size");
  }

  if (params.get("current")) {
    current = params.get("current");
  }

  option["limit"] = limit;
  option["offset"] = (current - 1) * limit;

  if (params.get("dates")) {
    const rangeDates = params.get("dates").split(",");
    option["rangFilter"] = JSON.stringify({
      value: rangeDates,
    });
  }

  if (params.get("status")) {
    option["status"] = params.get("status");
  }

  if (Object.keys(filter).length) {
    option["filter"] = JSON.stringify(filter);
  }

  if (searchStr) {
    option["search"] = JSON.stringify({
      column: ["Code", "Name"],
      value: searchStr,
    });
  }
  return getMany(option);
};

const handleSearch = (e) => {
  const queryParams = new URLSearchParams(document.location.search);
  const value = e.target.value;
  if (value) {
    queryParams.set("search", value);
  } else {
    queryParams.delete("search");
  }
  util.pushParamsToURL(pathName, queryParams.toString());
};

const filterFields = () => {
  const onChangeDate = (values) => {
    const queryParams = new URLSearchParams(document.location.search);
    if (values) {
      const dates = `${moment(values[0]).format("YYYY-MM-DD")},${moment(
        values[1]
      ).format("YYYY-MM-DD")}`;
      queryParams.set("dates", dates);
    } else {
      queryParams.delete("dates");
    }
    util.pushParamsToURL(pathName, queryParams.toString());
  };

  return (
    <div id="leave-date-rate">
      <InputRangeDate
        name="dates"
        label={t("text_date_rate")}
        placeholder={[t("text_dd_mm_yyyy"), t("text_dd_mm_yyyy")]}
        format="DD/MM/YYYY"
        onChange={onChangeDate}
        style={{
          width: "330px",
          height: "32px",
        }}
        separator={"~"}
      />
    </div>
  );
};

export default  withDataTable({
  title: t("text_leaves_request"),
  showFilter: true,
  showPagination: true,
  columns,
  pathName,
  defaultCurrent,
  defaultPageSize,
  showAddNew: true,
  showButtonUpdate: false,
  showButtonDelete: false,
  showHeader: true,
  showButtonInfo: true,
  topFilterItems: [
    { name: t("text_all"), value: "" },
    { name: t("text_pending"), value: 0 },
    { name: t("text_approved"), value: 1 },
    { name: t("text_rejected"), value: 2 }
  ],
  filterFields,
  handleSearch,
  FormInsertOrUpdate,
  getData,
  FormReview,
  handleAddNew: (modalRef, leaveType) => modalRef.showModal(leaveType),
  handleShowUpdate: (id, modalRef) => modalRef.showModal(id),
  handleShowDetail: (record, reviewRef) => reviewRef.showDrawer(record),
});
